import axios from "axios";

const { REACT_APP_BACKEND_API_URL } = process.env;

export const apiPostSignUpUserCreateFormat = async (payload: any) => {
  try {
    const url = `${REACT_APP_BACKEND_API_URL}/user-create-format`;
    const response = await axios.post(url, payload);
    return response?.data;
  } catch (e: any) {
    throw e?.response?.data ? e?.response?.data : e;
  }
};
